import { action } from 'satcheljs';

// Orchestrator for this action is inside owa-mail which opens the premium dashboard
export let openPremiumDashboard = action('openPremiumDashboard');
